"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var widget_toolbar_color_picker_html_1 = __importDefault(require("./widget-toolbar-color-picker.html"));
(function (module) {
    var WidgetToolbarColorPickerController = function () {
        this.clickAction = function ($value) {
            if (this.action) {
                this.action({ $name: 'color', $value: $value });
            }
        }.bind(this);
    };
    module.controller('WidgetToolbarColorPickerController', WidgetToolbarColorPickerController);
    module.component('prWidgetToolbarColorPicker', {
        templateUrl: widget_toolbar_color_picker_html_1.default,
        bindings: {
            icon: '<',
            selectedColor: '=',
            action: '&'
        },
        controller: 'WidgetToolbarColorPickerController'
    });
})(angular.module('qualtrics.pr'));
